// Provides "HEREDOC" functionality
// -> there is heredoc-ts, but since it uses `export` for the
//    function export, it won't load in tests here
function heredoc(text) {
    if (typeof text === "number") {
        return `${text}`
    }
    if (!text) {
        return "";
    }
    const
        useWindowsLineEndings = text.indexOf("\r\n") > -1,
        lineEnding = useWindowsLineEndings ? "\r\n" : "\n",
        lines = text.split("\n").map(line => line.replace(/\r$/, "")),
        collected = [],
        indent = determineIndentFrom(lines);
    for (const line of lines) {
        collected.push(
            stripIndent(
                line,
                indent
            )
        );
    }
    if (collected.length && collected[0] === "") {
        collected.shift();
    }
    if (collected.length && collected[collected.length - 1] === "") {
        collected.pop();
    }
    return collected.join(lineEnding);
}

const leadSpaceMatcher = /^(?<lead>\s+)/;

function stripIndent(line, indent) {
    const match = line.match(leadSpaceMatcher);
    if (!match) {
        return line;
    }
    const
        leadingSpace = match.groups["lead"]
            .replace("\t", "    ");
    if (leadingSpace.length >= indent) {
        return line.substring(leadingSpace.length);
    }
    return line.trimStart();
}

function determineIndentFrom(lines) {
    for (const line of lines) {
        if (isEmptyOrWhitespace(line)) {
            continue;
        }
        const match = line.match(leadSpaceMatcher);
        if (!match) {
            return 0;
        }
        return match.groups["lead"]
            .replace("\t", "    ")
            .length;
    }
    return 0;
}

function isEmptyOrWhitespace(line) {
    if (!line) {
        return true;
    }
    return /^\s$/.test(line);
}

window.Dashboard = window.Dashboard || {};
window.Dashboard.helpers = window.Dashboard.helpers || {};
window.Dashboard.helpers.heredoc = heredoc;
if (typeof module !== "undefined") {
    module.exports = {
        heredoc
    }
}
